import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaArrowLeft } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../components/Navbar';
import './ServicePage.css';

const APIDevelopment = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
    window.scrollTo(0, 0);
  }, []);

  const features = [
    'RESTful API development',
    'GraphQL API design',
    'API documentation',
    'Authentication & authorization',
    'Rate limiting & security',
    'API versioning',
    'Testing & optimization',
    'Third-party API integration'
  ];

  return (
    <div className="service-page">
      <Navbar />
      <div className="service-hero">
        <Link to="/" className="back-button" data-aos="fade-right">
          <FaArrowLeft /> Back to Home
        </Link>
        <div className="service-hero-content" data-aos="fade-up">
          <h1 className="service-page-title">API Development</h1>
          <p className="service-hero-tagline">Build robust, scalable APIs that power your applications.</p>
        </div>
      </div>

      <div className="service-content">
        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Overview</h2>
          <p className="section-text">
            We develop high-performance APIs using modern technologies and best practices. Our APIs are designed for 
            scalability, security, and seamless integration with your applications.
          </p>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">What You Get</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-item" data-aos="fade-up" data-aos-delay={index * 50}>
                <FaCheck className="check-icon" />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="service-cta" data-aos="fade-up">
          <Link to="/contact" className="cta-button-primary">
            Get Started →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default APIDevelopment;

